import React, { useEffect, useState } from "react";
import { Card, Row, Col, Table, Tag, Button, Space, message } from "antd";
import { API_CONFIG } from "./config";
import { apiFetch } from "../utils/apiFetch";

export default function Reports() {
  const [summary, setSummary] = useState(null);
  const [logs, setLogs] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [timeOffsetDays, setTimeOffsetDays] = useState(0);

  const load = async () => {
    const resSummary = await apiFetch(API_CONFIG.reportsSummaryUrl, { method: "POST" });
    const dataSummary = await resSummary.json();
    setSummary(dataSummary);
    const resLogs = await apiFetch(API_CONFIG.auditLogsUrl, { method: "POST" });
    const dataLogs = await resLogs.json();
    setLogs(dataLogs.logs || []);
    const resNotes = await apiFetch(API_CONFIG.notificationsListUrl, { method: "POST" });
    const dataNotes = await resNotes.json();
    setNotifications(dataNotes.notifications || []);
    const resOffset = await apiFetch(API_CONFIG.automationAdvanceUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ days: 0 }),
    });
    const dataOffset = await resOffset.json();
    setTimeOffsetDays(dataOffset.timeOffsetDays || 0);
  };

  useEffect(() => {
    load();
  }, []);

  const advanceDays = async (days) => {
    const res = await apiFetch(API_CONFIG.automationAdvanceUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ days }),
    });
    const data = await res.json();
    setTimeOffsetDays(data.timeOffsetDays || 0);
    message.success(`Advanced simulation by ${days} day(s)`);
    load();
  };

  const totals = summary?.totals || {};

  const logColumns = [
    { title: "Action", dataIndex: "Action", key: "Action" },
    { title: "User", dataIndex: "Username", key: "Username" },
    { title: "Result", dataIndex: "ResultType", key: "ResultType" },
    { title: "Time", dataIndex: "ActionTime", key: "ActionTime" },
    { title: "Details", dataIndex: "Details", key: "Details" },
  ];

  const notificationColumns = [
    { title: "Type", dataIndex: "type", key: "type", render: (v) => <Tag>{v}</Tag> },
    { title: "Message", dataIndex: "message", key: "message" },
    { title: "Due Date", dataIndex: "dueDate", key: "dueDate" },
  ];

  return (
    <div
      className="appverse-content table-container tabled luxe-dark"
      style={{
        background: "#000",
        minHeight: "100vh",
        marginLeft: "var(--sidenav-width, 88px)",
        padding: "0 20px 0 12px",
        position: "relative",
        zIndex: 1002,
      }}
    >
      <Row gutter={0}>
        <Col xs={24} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={6}><Card title="Total Leads" bordered={false}>{totals.totalLeads || 0}</Card></Col>
            <Col xs={24} md={6}><Card title="Bookings" bordered={false}>{totals.bookings || 0}</Card></Col>
            <Col xs={24} md={6}><Card title="Invoices" bordered={false}>{totals.invoices || 0}</Card></Col>
            <Col xs={24} md={6}><Card title="Revenue" bordered={false}>{summary?.revenue || 0}</Card></Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col xs={24} md={12}>
              <Card title="Operational Reports" bordered={false}>
                <p>Bankable: {totals.bankable || 0}</p>
                <p>Potential: {totals.potential || 0}</p>
                <p>Paid Invoices: {totals.paid || 0}</p>
                <p>Overdue Invoices: {totals.overdue || 0}</p>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="Compliance Reports" bordered={false}>
                <p>Audit events: {logs.length}</p>
                <p>Notifications: {notifications.length}</p>
                <p>User roles: Admin, Reviewer, Clerk</p>
                <Space style={{ marginTop: 8 }}>
                  <Button onClick={() => advanceDays(1)}>Simulate +1 Day</Button>
                  <Button onClick={() => advanceDays(7)}>Simulate +7 Days</Button>
                </Space>
                <div style={{ marginTop: 6, fontSize: 12, opacity: 0.7 }}>
                  Simulated offset: {timeOffsetDays} day(s)
                </div>
              </Card>
            </Col>
          </Row>

          <Card title="Audit Trail" bordered={false} style={{ marginTop: 16 }}>
            <Table rowKey={(r, i) => `${r.Action}-${i}`} dataSource={logs} columns={logColumns} />
          </Card>

          <Card title="Notifications" bordered={false} style={{ marginTop: 16 }}>
            <Table rowKey="id" dataSource={notifications} columns={notificationColumns} />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
